import TranslatedHtml from "@components/common/TranslatedHtml"
import { addNamespacePrefixIfNotPresent } from "@services/i18n"

interface IProps {
  error?: string
}

/**
 * This component provides a snipped to show a translation of an given error.
 */
const PageError: React.FC<IProps> = ({ error }: IProps) => {
  if (!error) {
    return null
  }

  return <p className="page-error text-danger">
    <TranslatedHtml content={addNamespacePrefixIfNotPresent("error", error)} />
  </p>
}

export default PageError
